import { render, staticRenderFns } from "./LandPageHeader.vue?vue&type=template&id=54c208e4&scoped=true"
import script from "./LandPageHeader.vue?vue&type=script&lang=js"
export * from "./LandPageHeader.vue?vue&type=script&lang=js"
import style0 from "./LandPageHeader.vue?vue&type=style&index=0&id=54c208e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c208e4",
  null
  
)

export default component.exports